/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemDropdownParameter } from './SystemDropdownParameter';
import {
    SystemDropdownParameterFromJSON,
    SystemDropdownParameterFromJSONTyped,
    SystemDropdownParameterToJSON,
    SystemDropdownParameterToJSONTyped,
} from './SystemDropdownParameter';
import type { SystemDropdownParameterKind } from './SystemDropdownParameterKind';
import {
    SystemDropdownParameterKindFromJSON,
    SystemDropdownParameterKindFromJSONTyped,
    SystemDropdownParameterKindToJSON,
    SystemDropdownParameterKindToJSONTyped,
} from './SystemDropdownParameterKind';

/**
 * 
 * @export
 * @interface SystemDropdownParameterDefinitionResponse
 */
export interface SystemDropdownParameterDefinitionResponse {
    /**
     * 
     * @type {SystemDropdownParameter}
     * @memberof SystemDropdownParameterDefinitionResponse
     */
    parameter: SystemDropdownParameter;
    /**
     * 
     * @type {SystemDropdownParameterKind}
     * @memberof SystemDropdownParameterDefinitionResponse
     */
    kind: SystemDropdownParameterKind;
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownParameterDefinitionResponse
     */
    defaultValue: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemDropdownParameterDefinitionResponse
     */
    allowedValues: Array<string>;
}



/**
 * Check if a given object implements the SystemDropdownParameterDefinitionResponse interface.
 */
export function instanceOfSystemDropdownParameterDefinitionResponse(value: object): value is SystemDropdownParameterDefinitionResponse {
    if (!('parameter' in value) || value['parameter'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('defaultValue' in value) || value['defaultValue'] === undefined) return false;
    if (!('allowedValues' in value) || value['allowedValues'] === undefined) return false;
    return true;
}

export function SystemDropdownParameterDefinitionResponseFromJSON(json: any): SystemDropdownParameterDefinitionResponse {
    return SystemDropdownParameterDefinitionResponseFromJSONTyped(json, false);
}

export function SystemDropdownParameterDefinitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemDropdownParameterDefinitionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'parameter': SystemDropdownParameterFromJSON(json['parameter']),
        'kind': SystemDropdownParameterKindFromJSON(json['kind']),
        'defaultValue': json['defaultValue'],
        'allowedValues': json['allowedValues'],
    };
}

export function SystemDropdownParameterDefinitionResponseToJSON(json: any): SystemDropdownParameterDefinitionResponse {
    return SystemDropdownParameterDefinitionResponseToJSONTyped(json, false);
}

export function SystemDropdownParameterDefinitionResponseToJSONTyped(value?: SystemDropdownParameterDefinitionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parameter': SystemDropdownParameterToJSON(value['parameter']),
        'kind': SystemDropdownParameterKindToJSON(value['kind']),
        'defaultValue': value['defaultValue'],
        'allowedValues': value['allowedValues'],
    };
}

